import { storage, auth } from '@/lib/firebase';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';

export const uploadResume = async (file: File, candidateEmail: string) => {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error('User not authenticated');
  }

  // Use the required path format: resumes/{userId}/{fileName}
  // Using the uploader's userId (Firebase UID) as per storage rules
  const storageRef = ref(storage, `resumes/${currentUser.uid}/${file.name}`);
  
  // Add required metadata for the Firebase function trigger
  const metadata = {
    customMetadata: {
      uploadedBy: currentUser.uid,
      candidateEmail: candidateEmail // Store candidate email in metadata for reference
    }
  };
  
  await uploadBytes(storageRef, file, metadata);
  const url = await getDownloadURL(storageRef);
  return url;
};

export const uploadReferralResume = async (file: File, candidateEmail: string, candidateUuid: string, jobId?: string) => {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error('User not authenticated');
  }

  // Create a unique filename with timestamp to avoid conflicts
  const timestamp = Date.now();
  const fileName = `${timestamp}-${file.name}`;
  
  // Use the required path format: resumes/{userId}/{fileName}
  // Using the uploader's userId (Firebase UID) as per storage rules
  const storageRef = ref(storage, `resumes/${currentUser.uid}/${fileName}`);
  
  // Add required metadata for the Firebase function trigger
  const metadata = {  
    customMetadata: {
      uploadedBy: currentUser.uid,
      candidateUuid: candidateUuid,
      candidateEmail: candidateEmail, // Store candidate email in metadata for reference
      jobId: jobId || '' // Store job ID in metadata if provided
    }
  };
  
  await uploadBytes(storageRef, file, metadata);
  const url = await getDownloadURL(storageRef);
  
  return {
    url,
    fileName,
    path: `resumes/${currentUser.uid}/${fileName}`
  };
};

export const deleteReferralResume = async (path: string) => {
  const storageRef = ref(storage, path);
  await deleteObject(storageRef);
};

export const getResumeUrl = async (path: string) => {
  const storageRef = ref(storage, path);
  return getDownloadURL(storageRef);
};
